import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "14",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#003DA6",
      d: "M10.473 5.435a.25.25 0 0 0 .184.075q.116 0 .188-.075a.26.26 0 0 0 .075-.188V5.04a1.2 1.2 0 0 0 .361-.129.8.8 0 0 0 .305-.282.73.73 0 0 0 .109-.398.65.65 0 0 0-.173-.47q-.17-.184-.526-.264l-.43-.094a.6.6 0 0 1-.228-.086.16.16 0 0 1-.06-.128q0-.113.105-.184a.56.56 0 0 1 .308-.072 1.15 1.15 0 0 1 .466.087.33.33 0 0 0 .2.03.24.24 0 0 0 .135-.087.26.26 0 0 0 .06-.142.3.3 0 0 0-.026-.162.25.25 0 0 0-.12-.124 1.458 1.458 0 0 0-.485-.156v-.19a.255.255 0 0 0-.264-.263.255.255 0 0 0-.26.263v.205a1.2 1.2 0 0 0-.36.126.86.86 0 0 0-.312.293.75.75 0 0 0-.11.402q0 .297.17.485.173.184.522.264l.425.09a.8.8 0 0 1 .177.06q.064.03.09.071.03.039.03.094a.18.18 0 0 1-.041.113.26.26 0 0 1-.132.08.8.8 0 0 1-.248.03 1.5 1.5 0 0 1-.38-.042q-.15-.045-.225-.087a.3.3 0 0 0-.2-.022.24.24 0 0 0-.135.094.34.34 0 0 0-.064.158.33.33 0 0 0 .03.169.28.28 0 0 0 .14.128q.116.052.3.105.142.04.324.057v.184q0 .113.075.188"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#003DA6",
      "fill-rule": "evenodd",
      d: "M14.64 4a4 4 0 1 1-8 0 4 4 0 0 1 8 0m-.76 0a3.24 3.24 0 1 1-6.482 0 3.24 3.24 0 0 1 6.482 0",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#003DA6",
      "fill-rule": "evenodd",
      d: "M0 8.735a1.709 1.709 0 0 1 3.374-.381L4.67 7.82a1.9 1.9 0 0 1 1.55.047l2.943 1.426c.248.12.425.325.515.562l4.554-1.043a1.299 1.299 0 0 1 .78 2.469l-5.605 2.284a1.9 1.9 0 0 1-1.604-.08l-2.92-1.546a1.14 1.14 0 0 0-1.118.03l-.404.242a1.71 1.71 0 0 1-3.36-.44zm9.658 1.905a1.036 1.036 0 0 1-1.387.52l-1.598-.752a.38.38 0 0 1 .323-.687l1.598.752a.274.274 0 0 0 .237-.495L5.889 8.55a1.14 1.14 0 0 0-.931-.028l-1.523.627-.018.007v2.136a1.9 1.9 0 0 1 1.821-.024l2.92 1.545c.297.158.65.175.962.048l5.605-2.283a.54.54 0 0 0-.324-1.026zm-7.95-2.854a.95.95 0 0 0-.949.95v3.037a.95.95 0 1 0 1.899 0V8.735a.95.95 0 0 0-.95-.949",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }